import clienteAxios from "../config/axios";

export const ApiCreditos = async ({
  url,
  params,
  setLoading
}) => {
  setLoading(true);

  const requestParams = {
    id: params.persona.id
  };

  // Solo agregar estados si tiene valor
  if (params.estados && params.estados !== "") {
    requestParams.estados = params.estados;
  }

  const response = await clienteAxios.get(
    url,
    {
      params: requestParams,
    }
  ).then((result) => {
    setLoading(false);
    return result.data.creditos;
  }).catch((result) => {
    setLoading(false);
    return [];
  });

  return response
}